// extracted by css-extract-rspack-plugin
export default {"cls1":"Comment-cls1_zKX","cls2":"Comment-cls2_Gzm Comment-cls1_zKX"};